import { ReleaseOrdersList } from "../../release-orders/components/ReleaseOrdersList";

export const ReleaseOrders = () => {
  return <ReleaseOrdersList removalType="CONTAINER" />;
};
